import { decodeFilter } from '@/utils/decode-filters'
import { stripRetiredAccountFilterKeys } from '@/utils/strip-retired-account-filter-keys'

/**
 * The one decode boundary for account-list filters. Every URL param and every
 * server-saved quick filter reaches Redux or the GraphQL request through here,
 * so the retired-key strip happens exactly once and covers an already-decoded
 * blob as well as an encoded one — a saved filter that still carries
 * `cash_raise_status` would otherwise take down the whole account-list query
 * once public-api drops the input field.
 */
export function decodeAccountListFilter<T>(
  rawFilter: string | T | null | undefined,
): T | null {
  if (!rawFilter) return null
  const decoded =
    typeof rawFilter === 'string'
      ? (decodeFilter(rawFilter) as T | null)
      : rawFilter
  return decoded ? stripRetiredAccountFilterKeys(decoded) : null
}
